// extracted by mini-css-extract-plugin
export default {"hover-only":"_16uWw","hoverOnly":"_16uWw","hover-only-and-collapsed":"_36BpH","hoverOnlyAndCollapsed":"_36BpH","hoverable":"_2R889","permanent-icon":"vrDjZ","permanentIcon":"vrDjZ"};